import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WheelSpinner from './Components/Raffle';
function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<WheelSpinner />} />
      </Routes>
    </Router>
  );
}

export default App;
